import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ReturnUrlService {
  private readonly RETURN_URL_KEY = 'oauth_return_url';
  private isBrowser: boolean;
  private authUrl: string = environment.authUrl;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  captureReturnUrl(params?: any): void {
    if (!this.isBrowser) return;

    if (params) {
      const returnUrl = params['return_url'];
      if (returnUrl) {
        this.storeReturnUrl(returnUrl);
      }
      return;
    }

    this.route.queryParams.subscribe(params => {
      const returnUrl = params['return_url'];
      if (returnUrl) {
        this.storeReturnUrl(returnUrl);
      }
    });
  }

  private storeReturnUrl(url: string): void {
    try {
      sessionStorage.setItem(this.RETURN_URL_KEY, url);
    } catch (e) {
      console.warn('Could not store return URL:', e);
    }
  }

  getReturnUrl(): string | null {
    if (!this.isBrowser) return null;
    try {
      return sessionStorage.getItem(this.RETURN_URL_KEY);
    } catch (e) {
      return null;
    }
  }

  clearReturnUrl(): void {
    if (!this.isBrowser) return;
    try {
      sessionStorage.removeItem(this.RETURN_URL_KEY);
    } catch (e) {
      // Silently fail if sessionStorage is not available
    }
  }

  redirectAfterAuth(defaultRoute: string = '/', token: string): void {
    if (!this.isBrowser) {
      this.router.navigate([defaultRoute]);
      return;
    }

    const returnUrl = this.getReturnUrl();
    
    if (returnUrl && this.isValidReturnUrl(returnUrl)) {
      this.clearReturnUrl();
      window.location.href = `${this.authUrl}/auth/sso-bridge?redirect_to=${encodeURIComponent(returnUrl)}&token=${token}`;
      // if (returnUrl.startsWith(window.location.origin) || returnUrl.startsWith('/')) {
      //   this.router.navigateByUrl(returnUrl).catch(() => {
      //     window.location.href = returnUrl;
      //   });
      // } else {
      //   window.location.href = returnUrl;
      // }
    } else {
      this.router.navigate([defaultRoute]);
    }
  }

  private isValidReturnUrl(url: string): boolean {
    if (!this.isBrowser) {
      // In SSR, only allow relative paths
      return url.startsWith('/');
    }

    try {
      const urlObj = new URL(url, window.location.origin);
      const currentOrigin = window.location.origin;
      
      // Allow same origin URLs
      if (urlObj.origin === currentOrigin) return true;
      
      // Allow OAuth authorize endpoints
      if (urlObj.pathname.includes('/oauth/authorize')) return true;
      
      return false;
    } catch (e) {
      // If URL parsing fails, check if it's a relative path
      if (url.startsWith('/')) {
        return true;
      }
      return false;
    }
  }
}

